import { Observable } from 'rxjs';
import { Poblacion, PoblacionFiltro, PoblacionSearchResponse } from '../../model/transporte/poblacion';

/**
 * Puerto abstracto: Repositorio de Población/Tarifas de Transporte
 * 
 * Define las operaciones disponibles para consultar poblaciones
 * y tarifas de transporte desde W094_SGS_TARIFAS_TRANSPORTE.
 * 
 * @author Emerson Rodriguez - Ingeneo
 */
export abstract class PoblacionRepository {
  
  /**
   * Busca poblaciones disponibles según municipios de origen y destino, con
   * paginación keyset/cursor (skill acceso-datos-oracle §7 — nunca OFFSET).
   *
   * @param filtro Filtros de búsqueda (requiere ambos municipios)
   * @param cursor Cursor de la página (null = primera página)
   * @param size Tamaño de página
   * @param direction 'NEXT' | 'PREVIOUS' | 'LAST'
   * @returns Página de poblaciones con sus tarifas
   */
  abstract buscarPoblaciones(
    filtro: PoblacionFiltro,
    cursor: string | null,
    size: number,
    direction: 'NEXT' | 'PREVIOUS' | 'LAST'
  ): Observable<PoblacionSearchResponse>;
  
  /**
   * Obtiene una tarifa de transporte específica.
   * 
   * @param cdsuraOrigen Código SURA municipio origen
   * @param cdsuraDestino Código SURA municipio destino
   * @param cdpoblacion Código de población
   * @returns La población con su tarifa
   */
  abstract obtenerTarifa(
    cdsuraOrigen: string,
    cdsuraDestino: string,
    cdpoblacion?: string,
    nmconsecutivoOficina?: number,
    nmconsecutivoCliente?: number,
    nmconsecutivoAsesor?: number
  ): Observable<Poblacion | null>;
}
